import { addNotify } from 'features/notify';
import { getErrorMessage } from 'shared/helpers/getErrorMessage';

const actionTypes = {
  ACTION_PROCESSING: 'sportHistory/ACTION_PROCESSING',
  GET_FEEDBACK_LINK: 'agentFeedback/GET_FEEDBACK_LINK',
};
const setActionProcessing = actionProcessing => async dispatch => {
  dispatch({
    type: actionTypes.ACTION_PROCESSING,
    payload: {
      [actionTypes.ACTION_PROCESSING]: actionProcessing,
    },
  });
};

const getFeedbackLink = () => async (dispatch, getState, extra) => {
  const { api } = extra;
  const { locale } = getState().locale;

  dispatch(setActionProcessing(true));

  const response = await api.agentAdmin.getFeedbackLink();
  const errorMessage = getErrorMessage(locale, response);

  if (response.success) {
    dispatch({ type: actionTypes.GET_FEEDBACK_LINK, payload: response.data });
  } else {
    dispatch(addNotify(errorMessage, 'error'));
  }
  dispatch(setActionProcessing(false));
};

const updateFeedbackLink = (link, callback) => async (dispatch, getState, extra) => {
  const { api } = extra;
  const { locale } = getState().locale;

  dispatch(setActionProcessing(true));

  const response = await api.agentAdmin.updateFeedbackLink(link);
  const errorMessage = getErrorMessage(locale, response);

  if (response.success) {
    dispatch(addNotify(locale.createSuccess, 'success'));
    dispatch(getFeedbackLink());
    callback && callback();
  } else {
    dispatch(addNotify(errorMessage, 'error'));
  }
  dispatch(setActionProcessing(false));
};

export { actionTypes, getFeedbackLink, updateFeedbackLink };
